import React from 'react'

const StepperContext = React.createContext()

export default StepperContext
